import { Reducer } from 'redux';
import { ImportFile, InitialImportFile, Rating } from './types';
import { freightTypeEnum } from '../../../hooks/freights/useConfigureFreight';

const INITIAL_STATE: InitialImportFile = {
  type: '',
  totalValue: 0,
  freights: {
    page: 0,
    totalRecords: 0,
    rows: [],
  },
  deliveries: [],
  freightCost: 0,
  totalKilometers: 0,
  priceWithFee: 0,
  vehicleTypeId: '',
  vehicleType: '',
  numberOfHelpers: 0,
  totalWeight: 0,
  message: '',
  freight: {
    freightRequest: [],
    totalValue: 0,
    freightId: '',
    freightCost: 0,
    totalKilometers: 0,
    numberOfHelpers: 0,
    deliveryLimitDate: '',
    freightStatus: '',
    vehicleTypePrice: 0,
    totalWeight: 0,
    pickUpDate: '',
    acceptDate: '',
    createdAt: '',
    updatedAt: '',
    freightType: freightTypeEnum.PUBLIC,
    distributor: {
      distributorId: '',
      name: '',
      cnpj: '',
      stateRegistration: '',
      streetAddress: '',
      streetNumber: '',
      zipCode: '',
      state: '',
      city: '',
      neighborhood: '',
      latitude: '',
      longitude: '',
      fee: 0,
      feeType: '',
      status: '',
      createdAt: '',
      updatedAt: '',
    },
    vehicleType: {
      vehicleTypeId: '',
      vehicleType: '',
      payloadCapacity: '',
      packLoadWeight: '',
      costPerAssistant: '',
      driverCost: '',
      costPerKilometer: '',
      costPerTon: '',
      costPerCubicMeter: '',
      costPerOrder: '',
      createdAt: '',
      updatedAt: '',
    },
    driver: {
      driverId: '',
      username: '',
      email: '',
      cpf: '',
      rg: '',
      phoneNumber: '',
      status: '',
      createdAt: '',
      updatedAt: '',
    },
    deliveries: [],
  },
  ratingDriver: {
    rating: 0,

    description: '',
  },
};

const reducerFreight: Reducer<InitialImportFile> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case ImportFile.IMPORT_FILE_SUCCESS: {
      const newState = { ...state };
      newState.message = action.payload.message;
      newState.type = action.payload.type;
      newState.freights = action.payload.freights;

      return newState;
    }

    case ImportFile.IMPORT_FILE_FAILURE: {
      const newState = { ...INITIAL_STATE };
      return newState;
    }

    case ImportFile.CALCULATE_FREIGHT_SUCCESS: {
      const newState = { ...state };

      newState.deliveries = action.payload.deliveries;
      newState.freightCost = action.payload.freightCost;
      newState.totalValue = action.payload.totalValue;
      newState.totalKilometers = action.payload.totalKilometers;
      newState.priceWithFee = action.payload.priceWithFee;
      newState.vehicleTypeId = action.payload.vehicleTypeId;
      newState.vehicleType = action.payload.vehicleType;
      newState.numberOfHelpers = action.payload.numberOfHelpers;
      newState.totalWeight = action.payload.totalWeight;

      return newState;
    }

    case ImportFile.SHOW_FREIGHT: {
      const newState = { ...INITIAL_STATE };
      newState.freight = action.payload.freight;
      return newState;
    }

    case ImportFile.GET_DELIVERIES: {
      const newState = { ...INITIAL_STATE };
      newState.freight.deliveries = action.payload;
      return newState;
    }

    case ImportFile.UPDATE_DELIVERY: {
      const newState = { ...INITIAL_STATE };
      newState.freight.deliveries = newState.freight.deliveries.map(
        delivery => {
          if (delivery.deliveryId === action.payload.deliveryId) {
            return {
              ...action.payload,
            };
          }
          return delivery;
        },
      );
      return newState;
    }

    case Rating.GET_RATING_DRIVER: {
      const newState = { ...INITIAL_STATE };
      newState.ratingDriver = { ...action.payload };

      return newState;
    }

    default:
      return state;
  }
};

export default reducerFreight;
